import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const BannerBarTheme = {
    bannerBar: {
        light: {
            variants: {
                default: {
                    background: Colors.greyWhite,
                    color: Colors.black,
                    closeButton: {
                        enabled: withOpacity(Colors.black, Opacities.medium),
                        hover: Colors.black,
                    },
                    readMoreButton: { iconColor: Colors.accessibleSafetyOrange },
                },
                critical: {
                    background: Colors.parisDaisy,
                    color: Colors.black,
                    readMoreButton: { iconColor: 'currentColor !important' },
                    closeButton: {
                        enabled: Colors.black,
                        hover: withOpacity(Colors.black, Opacities.medium),
                    },
                    iconColor: Colors.black,
                },
            },
        },
        dark: {
            variants: {
                default: {
                    background: withOpacity(Colors.white, Opacities.xLow),
                    color: Colors.white,
                    closeButton: {
                        enabled: withOpacity(Colors.white, Opacities.medium),
                        hover: Colors.white,
                    },
                    readMoreButton: { iconColor: Colors.accessibleSafetyOrange },
                },
            },
        },
    },
};
export default BannerBarTheme;
